export function useLogout() {
  const { public: env } = useRuntimeConfig();

  const { clear } = useUserSession();

  const { origin } = useRequestURL();

  return async function logout() {
    try {
      await clear();
    } catch {
      // Ignored
    }

    return navigateTo(
      {
        path: `${env.urls.core.external}/lokus/am/frontend/logout`,
        query: {
          redirect: origin,
        },
      },
      {
        external: true,
      },
    );
  };
}
